import React, { useEffect, useMemo, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import DataTable from '../../components/DataTable'
import Loading from '../../layout/Loading'
import InfoService from '../../service/InfoService'
import DialogContext from '../../Authentication/DialogContext'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import Authorization from '../../Authentication/Authorization'
import { TFunction } from 'i18next'
import { ConfirmDialogProps } from '../../components/ConfirmDialog'

const Version = (props: any) => {
  const [versions, setVersions] = useState([] as any[])
  const [loading, setLoading] = useState(true)
  const { confirmDialogPropsSetter } = useContext(DialogContext)
  const { t } = useTranslation()

  const { classes = '', searchable = true, sortable = true, useCaption = true } = props

  useEffect(() => {
    InfoService.getVersions()
      .then((versions: any[]) => setVersions(versions))
      .finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: t('productName'),
        dataField: 'productname',
        sort: sortable,
        classes,
      },
      {
        text: t('description.text'),
        dataField: 'info',
        sort: sortable,
        classes,
        formatter: (cell: any, row: any) => (cell ? cell : row.productname),
      },
      {
        text: t('version'),
        dataField: 'versionnumber',
        sort: sortable,
        classes,
        formatter: (cell: any, row: any) => `${cell} - ${row.buildnumber}`,
      },
    ]
  }, [t, classes, sortable])

  const defaultSorted = [
    {
      dataField: 'productname',
      order: 'asc',
    },
  ]

  const caption = useCaption ? t('version') : undefined
  const captionButtons = useCaption
    ? [
        {
          onClick: () => downloadHealthInfo(t, confirmDialogPropsSetter),
          text: t('healthInfo.text'),
          icon: faDownload,
          permissions: Authorization.info.version,
        },
      ]
    : undefined

  return (
    <Loading isLoading={loading}>
      <DataTable
        keyField='productname'
        data={versions}
        searchable={searchable}
        columns={columns}
        caption={caption}
        defaultSorted={defaultSorted}
        captionButtons={captionButtons}
      />
    </Loading>
  )
}

function downloadHealthInfo(t: TFunction, confirmDialogPropsSetter: any) {
  const props: ConfirmDialogProps = {
    show: true,
    header: t('healthInfo.downloadHeader'),
    body: t('healthInfo.downloadBody'),
    submitText: t('yes'),
    onSubmit: InfoService.downloadHealthInfo,
    cancelText: t('no'),
  }
  confirmDialogPropsSetter(props)
}

export default Version
